// extracted by mini-css-extract-plugin
export default {"contentWrapper":"App_contentWrapper__go5Q2","bodyBlock":"App_bodyBlock__1G3bl","menuBlock":"App_menuBlock__5BLzF","contentBlock":"App_contentBlock__1eZLc"};